import React from "react";

import { Typography } from "clearsense-ui/components";

import FieldTooltip from "../SurvivorshipDomainRecord/InformationCard/FieldTooltip";

const TabHeader = ({ recordDetails, searchIdentifier }) => {
  const providerData =
    recordDetails?.result?.[0]?.truth_system_value &&
    JSON.parse(recordDetails?.result?.[0]?.truth_system_value).sort(
      (a, b) => a?.sort_order - b?.sort_order
    )?.[0];
  const first_name_details =
    providerData?.["NPI Details"]?.[0]?.["Practitioner First Name"];
  const last_name_details =
    providerData?.["NPI Details"]?.[1]?.["Practitioner Last Name"];
  const business_entity_name =
    providerData?.["Business Entity"]?.[0]?.["Business Entity Name"];
  const isTin = searchIdentifier.context_cde === "Tax ID Number";

  return (
    <Typography
      style="h3"
      type="bold"
      className="text-primary-shade flex items-center"
    >
      {isTin ? (
        <FieldTooltip
          key="business_entity_name"
          cde_source_system={
            business_entity_name?.cde_values?.[0]?.cde_source_system
          }
          cde_updated_date={
            business_entity_name?.cde_values?.[0]?.cde_updated_date
          }
        >
          {business_entity_name?.cde_values?.[0]?.value ?? ""}
        </FieldTooltip>
      ) : (
        <>
          <FieldTooltip
            key="last_name"
            cde_source_system={
              last_name_details?.cde_values?.[0]?.cde_source_system
            }
            cde_updated_date={
              last_name_details?.cde_values?.[0]?.cde_updated_date
            }
          >
            {last_name_details?.cde_values?.[0]?.value
              ? `${last_name_details?.cde_values?.[0]?.value},`
              : ""}
          </FieldTooltip>
          &nbsp;
          <FieldTooltip
            key="first_name"
            cde_source_system={
              first_name_details?.cde_values?.[0]?.cde_source_system
            }
            cde_updated_date={
              first_name_details?.cde_values?.[0]?.cde_updated_date
            }
          >
            {first_name_details?.cde_values?.[0]?.value ?? ""}
          </FieldTooltip>
        </>
      )}
      &nbsp;
      {`| ${isTin ? "TIN" : "NPI"}: ${searchIdentifier.context_value}`}
    </Typography>
  );
};

export default TabHeader;
